import { combineReducers } from "redux";

import infoReducer from "./CcpaForm/infoReducer";
import initialReducer from "./InitialLoad/initialReducer";
import mailingAddressReducer from "./MailingAddressSelector/mailingAddressReducer";
import suggestedMailingAddressReducer from "./MailingAddressSelector/suggestedMailingAddressReducer";
import verificationReducer from "./VerificationForm/verificationReducer";
import stateSelectorReducer from './StateSelector/stateSelectorReducer';
import requestSelectorReducer from './RequestSelector/requestSelectorReducer'
import statusFormReducer from "./StatusForm/statusFormReducer"
import getExperianReducer from "./ExperianForm/getExperianReducer";
import VerifyExperianReducer from "./ExperianForm/verifyExperianReducer";
import requestFormReducer from "./requestForm/requestFormReducer";
import errorsReducer from "./Errors/reducer";
import rightToCorrectReducer from './RightToCorrect/rightToCorrectReducer';
import suggestedCorrectedAddressReducer from './RightToCorrect/suggestedMailingAddressReducer';
import secureKeyReducer from './SecureKey/getUserReducer';
import getProtectionServicesExperianReducer from "./ProtectionServicesExperianForm/getProtectionServicesExperianReducer";
import verifyProtectionServicesExperianReducer from "./ProtectionServicesExperianForm/verifyProtectionServicesExperianReducer";

const rootReducer = combineReducers({
    initialReducer: initialReducer,
    info: infoReducer,
    mailingAddress: mailingAddressReducer,
    suggestedMailingAddress: suggestedMailingAddressReducer,
    verificationReducer: verificationReducer,
    stateSelector: stateSelectorReducer,
    requestSelector: requestSelectorReducer,
    statusFormReducer:statusFormReducer,
    getExperianReducer: getExperianReducer,
    verifyExperianReducer: VerifyExperianReducer,
    getProtectionServicesExperianReducer: getProtectionServicesExperianReducer,
    verifyProtectionServicesExperianReducer: verifyProtectionServicesExperianReducer,
    requestForm: requestFormReducer,
    rightToCorrectReducer: rightToCorrectReducer,
    suggestedCorrectedAddressReducer: suggestedCorrectedAddressReducer,
    networkError: errorsReducer,
    secureKey: secureKeyReducer,
});

export default rootReducer;